export const NOTIFICATION_USER_CREATION = "NOTIFICATION_USER_CREATION";
export const NOTIFICATION_PROGRAM_ASSIGNED = "NOTIFICATION_PROGRAM_ASSIGNED";
export const NOTIFICATION_PROGRAM_INCOMPLETE =
  "NOTIFICATION_PROGRAM_INCOMPLETE";
export const NOTIFICATION_PROGRAM_OVERDUE = "NOTIFICATION_PROGRAM_OVERDUE";
export const NOTIFICATION_PROGRAM_COMPLETED = "NOTIFICATION_PROGRAM_COMPLETED";
export const NOTIFICATION_CUSTOM = "NOTIFICATION_CUSTOM";

export const NOTIFICATION_TYPES = [
  {
    id: NOTIFICATION_USER_CREATION,
    value: 1,
    label: NOTIFICATION_USER_CREATION,
    severity: "info",
    summary: "New User Created",
  },
  {
    id: NOTIFICATION_PROGRAM_ASSIGNED,
    value: 2,
    label: NOTIFICATION_PROGRAM_ASSIGNED,
    severity: "info",
    summary: "Program Assigned",
  },
  {
    id: NOTIFICATION_PROGRAM_INCOMPLETE,
    value: 3,
    label: NOTIFICATION_PROGRAM_INCOMPLETE,
    severity: "warn",
    summary: "Program Incomplete",
  },
  {
    id: NOTIFICATION_PROGRAM_OVERDUE,
    value: 4,
    label: NOTIFICATION_PROGRAM_OVERDUE,
    severity: "error",
    summary: "Program Overdue",
  },
  {
    id: NOTIFICATION_PROGRAM_COMPLETED,
    value: 6,
    label: NOTIFICATION_PROGRAM_COMPLETED,
    severity: "success",
    summary: "Program Completed",
  },
  {
    id: NOTIFICATION_CUSTOM,
    value: 8,
    label: "Notification",
    severity: "info",
    summary: "Custom Notification",
  }

];
